export default __webpack_public_path__ + "static/media/Image2_Desktop.e61efb54.png";